import styled from 'styled-components'
import { Skeleton } from '~/components/shared'

export const Container = styled.div`
  position: relative;
  margin: 20px;
  height: calc(100vh - 78px);
  overflow: hidden;
`
export const MessageError = styled.p`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
  padding-top: 50%;
`
export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
`
export const SkeletonItem = styled(Skeleton).attrs(props => ({
  baseColor: props.theme.colors.colorf2f7ff
}))`
  margin-bottom: 10px;
  border-radius: 2px;
  margin-right: 8px;
`
export const ContentInLine = styled.div`
  display: flex;
  flex-direction: row;
`
